import '../../Styles/LotteryTicket/_lotteryTicketSlider.scss';

await import('Feature/LotteryContentElements/code/Scripts/LotteryTicket/explanationSlider');

await import(/* webpackChunkName: "base64" */ 'Common/Scripts/Common/base64');

window.am = window.am || {};

window.am.lotteryTicketSlider = new function () {
    var that = this;

    that.init = function () {

        var explanationSliders = document.querySelectorAll('.lotteryticket-explanation-slider');

        if (explanationSliders == null || explanationSliders.length == 0) {
            return;
        }

        for (var i = 0; i < explanationSliders.length; i++) {
            initExplanationSlider(explanationSliders[i]);
        }
    }

    function initExplanationSlider(slider) {
        var base64Content = slider.getAttribute('data-content');
        var content = window.am.base64.decode(base64Content);
        /* get string in base64 decode and parse to json */
        var content = JSON.parse(content);

        new window.am.explanationSlider(slider, content);
    }
}

window.am.lotteryTicketSlider.init();